const SCOPED_ACCOUNT_KEY = "pondstat_scoped_account";

/**
 * Persist which pond-owner account Company/Super is currently working on.
 * Does not change auth tokens — identity stays company or super.
 */
export function setScopedAccount(account) {
  if (!account?.id && account?.id !== 0) {
    clearScopedAccount();
    return;
  }
  const payload = {
    id: Number(account.id),
    name: account.name || account.FullName || null,
    email: account.email || account.Email || null,
  };
  localStorage.setItem(SCOPED_ACCOUNT_KEY, JSON.stringify(payload));
  window.dispatchEvent(new Event("pondstat-scoped-account-changed"));
}

export function getScopedAccount() {
  try {
    const raw = localStorage.getItem(SCOPED_ACCOUNT_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (data?.id == null || Number.isNaN(Number(data.id))) return null;
    return {
      id: Number(data.id),
      name: data.name || null,
      email: data.email || null,
    };
  } catch {
    return null;
  }
}

export function getScopedAccountId() {
  return getScopedAccount()?.id ?? null;
}

export function clearScopedAccount() {
  localStorage.removeItem(SCOPED_ACCOUNT_KEY);
  window.dispatchEvent(new Event("pondstat-scoped-account-changed"));
}

export function isActingAsScopedAccount() {
  return getScopedAccountId() != null;
}

/** Open a managed account in full Admin UI without switching JWT. */
export function openScopedAccount(account, { history, path = "/dashboard" } = {}) {
  setScopedAccount(account);
  if (history?.push) {
    history.push(path);
  } else {
    window.location.assign(path);
  }
}

export function leaveScopedAccount({ history, path = "/company/accounts" } = {}) {
  clearScopedAccount();
  if (history?.push) {
    history.push(path);
  } else {
    window.location.assign(path);
  }
}
